/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// addToCart
// updateCart

window.updateFreeCushionPad = {
  pads: {
    "30cm x 50cm": 44504465080621,
    "40cm x 60cm": 44504464916781,
    "45cm x 45cm": 44504464949549,
    "50cm x 50cm": 44504464687405
  },
  applicablePdts: ["hand-woven-cushion-navy-blue-grey", "hand-woven-cushion-in-terracotta-and-grey", "kantha-stitch-1", "kantha-stitch-2"],
  apiRoot: theme.routes.root,
  padsList: [],
  init: function init(type, before, button) {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var showCart, res, _yield$res$json, items, cushions, _cushions, beforeCushions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            showCart = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : true;
            _context.prev = 1;
            // console.log(type, button);
            if (button !== null && button !== void 0 && button.hasAttribute("ga-buy-now")) showCart = false;
            _this.padsList = [];
            _context.next = 6;
            return fetch(_this.apiRoot + "cart.js");
          case 6:
            res = _context.sent;
            _context.next = 9;
            return res.json();
          case 9:
            _yield$res$json = _context.sent;
            items = _yield$res$json.items;
            if (!(type === "addToCart")) {
              _context.next = 20;
              break;
            }
            cushions = items.filter(_this.checkCushions.bind(_this));
            if (cushions.length) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            cushions.forEach(function (c) {
              var _Object$keys$filter = Object.keys(_this.pads).filter(function (p) {
                  return c.variant_title.toLowerCase().includes(p);
                }),
                _Object$keys$filter2 = _slicedToArray(_Object$keys$filter, 1),
                corresPadKey = _Object$keys$filter2[0];
              //   check if the cushion exists
              var _items$filter = items.filter(function (item) {
                  return item.variant_id === _this.pads[corresPadKey];
                }),
                _items$filter2 = _slicedToArray(_items$filter, 1),
                corresPad = _items$filter2[0];
              // console.log(corresPad);
              if (corresPad) {
                _this.addToPadsList("change", corresPadKey, {
                  id: corresPad.variant_id,
                  quantity: c.quantity
                });
              } else {
                _this.addToPadsList("add", corresPadKey, {
                  id: _this.pads[corresPadKey],
                  quantity: c.quantity
                });
              }
            });
            _context.next = 18;
            return _this.updateCart();
          case 18:
            _context.next = 27;
            break;
          case 20:
            _cushions = items.filter(_this.checkCushions.bind(_this));
            beforeCushions = before.items.filter(function (item) {
              return _this.applicablePdts.includes(item.handle) && !_cushions.some(function (citem) {
                return citem.key === item.key;
              });
            }); // console.log(cushions, beforeCushions);
            if (_cushions.length) {
              _cushions.forEach(function (c) {
                var _Object$keys$filter3 = Object.keys(_this.pads).filter(function (p) {
                    return c.variant_title.toLowerCase().includes(p);
                  }),
                  _Object$keys$filter4 = _slicedToArray(_Object$keys$filter3, 1),
                  corresPadKey = _Object$keys$filter4[0];
                _this.addToPadsList("change", corresPadKey, {
                  id: _this.pads[corresPadKey],
                  quantity: c.quantity
                });
              });
            }
            if (beforeCushions.length) {
              beforeCushions.forEach(function (c) {
                var _Object$keys$filter5 = Object.keys(_this.pads).filter(function (p) {
                    return c.variant_title.toLowerCase().includes(p);
                  }),
                  _Object$keys$filter6 = _slicedToArray(_Object$keys$filter5, 1),
                  corresPadKey = _Object$keys$filter6[0];
                //   check if the cushion exists
                var _items$filter3 = items.filter(function (item) {
                    return item.variant_id === _this.pads[corresPadKey];
                  }),
                  _items$filter4 = _slicedToArray(_items$filter3, 1),
                  corresPad = _items$filter4[0];
                // debugger;
                _this.addToPadsList("change", corresPadKey, {
                  id: corresPad.variant_id,
                  quantity: corresPad.quantity - (corresPad.quantity - c.quantity)
                });
                _this.addToPadsList("change", corresPadKey, {
                  id: corresPad.variant_id,
                  quantity: -c.quantity
                });
              });
            }
            // console.log(this.padsList);
            _context.next = 26;
            return _this.updateCart();
          case 26:
            // debugger;
            setTimeout(function () {
              cart.getCart();
              if (document.querySelector(".cart-drawer__items.aos-init").innerHTML === "[object HTMLDivElement]") {
                // console.log(true);
                cart.getCart();
              }
            }, 1000);
          case 27:
            _context.next = 31;
            break;
          case 29:
            _context.prev = 29;
            _context.t0 = _context["catch"](1);
          case 31:
            _context.prev = 31;
            if (showCart) {
              cart.getCart();
            } else {
              window.location.href = "/checkout";
            }
            return _context.finish(31);
          case 34:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 29, 31, 34]]);
    }))();
  },
  checkCushions: function checkCushions(item) {
    return this.applicablePdts.includes(item.handle);
  },
  add: function add(id, qty) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(_this2.apiRoot + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                items: [{
                  id: id,
                  quantity: qty
                }]
              })
            });
          case 3:
            _context2.next = 8;
            break;
          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2["catch"](0);
            throw _context2.t0;
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 5]]);
    }))();
  },
  change: function change(id, qty) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            qty = qty >= 0 ? qty : 0;
            _context3.prev = 1;
            _context3.next = 4;
            return fetch(_this3.apiRoot + "cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates: _defineProperty({}, id, qty)
              })
            });
          case 4:
            _context3.next = 9;
            break;
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](1);
            throw _context3.t0;
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 6]]);
    }))();
  },
  addToPadsList: function addToPadsList(event, corresPadKey, options) {
    var _this$padsList$filter = this.padsList.filter(function (p) {
        return p.pad === corresPadKey;
      }),
      _this$padsList$filter2 = _slicedToArray(_this$padsList$filter, 1),
      corresPad = _this$padsList$filter2[0];
    if (!corresPad) {
      this.padsList.push({
        pad: corresPadKey,
        event: event,
        options: options
      });
    } else {
      corresPad.options.quantity += options.quantity;
    }
  },
  updateCart: function updateCart() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this4.padsList.forEach( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(p) {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!(p.event === "add")) {
                        _context4.next = 5;
                        break;
                      }
                      _context4.next = 3;
                      return _this4.add(p.options.id, p.options.quantity);
                    case 3:
                      _context4.next = 7;
                      break;
                    case 5:
                      _context4.next = 7;
                      return _this4.change(p.options.id, p.options.quantity);
                    case 7:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }());
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};
var productsSearch = {
  input: document.querySelector("[data-nav-search-input]"),
  results: document.querySelector("[hdl-search-results]"),
  form: document.querySelector("form.search-form"),
  init: function init() {
    var _this5 = this;
    this.form.addEventListener("submit", function (e) {
      e.preventDefault();
      _this5.handleSearch();
    });
    this.input.addEventListener("input", this.handleSearch.bind(this));
  },
  handleSearch: function handleSearch() {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var query, searchResponse, data, products, _products$querySelect;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            query = _this6.input.value;
            _context6.next = 4;
            return fetch("/search?q=".concat(query, "&type=product&section_id=search"));
          case 4:
            searchResponse = _context6.sent;
            if (searchResponse.ok) {
              _context6.next = 7;
              break;
            }
            throw new Error("Issue while fetching");
          case 7:
            _context6.next = 9;
            return searchResponse.text();
          case 9:
            data = _context6.sent;
            products = new DOMParser().parseFromString(data, "text/html").querySelector("[data-collection-products]");
            if (products.innerHTML) {
              _this6.results.innerHTML = "";
              (_products$querySelect = products.querySelectorAll(".product-grid-item__info")) === null || _products$querySelect === void 0 ? void 0 : _products$querySelect.forEach(function (info) {
                return info.classList.add("aos-init", "aos-animate");
              });
              _this6.results.insertAdjacentElement("beforeend", products);
              setTimeout(function () {
                GA.colorSwatches();
              }, 2000);
            } else {
              _this6.results.innerHTML = "No product found";
            }
            _context6.next = 17;
            break;
          case 14:
            _context6.prev = 14;
            _context6.t0 = _context6["catch"](0);
            console.log(_context6.t0.message);
          case 17:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 14]]);
    }))();
  }
};
productsSearch.init();
/******/ })()
;